import React, { useState } from 'react';
import { useViewlogies } from 'context';

const ProductCard = ({ product, onSelect }) => {
    const {
        event: { color },
    } = useViewlogies();

    const [imageIndex, setImageIndex] = useState(0);
    const imageCount = product.images.length;

    const showPreviousImage = () => setImageIndex(index => (index - 1 + imageCount) % imageCount);
    const showNextImage = () => setImageIndex(index => (index + 1) % imageCount);

    return (
        <div className="care-package-product-card">
            {product.isBestseller && <div className="care-package-bestseller-badge">Bestseller</div>}
            <div className="care-package-product-image-container">
                <img src={product.images[imageIndex]} alt={product.name} className="care-package-product-image" />
                {imageCount > 1 && (
                    <>
                        <button
                            className="care-package-image-arrow left"
                            onClick={showPreviousImage}
                            aria-label="Previous image"
                            type="button"
                        >
                            &#8249;
                        </button>
                        <button
                            className="care-package-image-arrow right"
                            onClick={showNextImage}
                            aria-label="Next image"
                            type="button"
                        >
                            &#8250;
                        </button>
                    </>
                )}
            </div>
            <div className="care-package-product-info">
                {product.reviewImage && (
                    <img
                        src={product.reviewImage}
                        alt={`${product.name} reviews`}
                        className="care-package-review-image"
                    />
                )}
                <div className="care-package-product-name">{product.name}</div>
                <div className="care-package-product-price">${product.price.toFixed(2)}</div>
                <button
                    className="care-package-btn"
                    style={{ backgroundColor: color }}
                    onClick={() => onSelect(product)}
                    type="button"
                >
                    Select
                </button>
            </div>
        </div>
    );
};

export default ProductCard;
